import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import Textarea from "components/atoms/Textarea/Textarea";
import FormField from "components/molecules/FormField/FormField";

function AdditionalInformation() {
  const intl = useIntl();

  return (
    <div>
      <Row className="mb-24">
        <Col lg={2} md={3}>
          <h6>
            <FormattedMessage
              id="new-request.quote-confirmation.schedule.additionalInformation"
              defaultMessage="Addition Information"
            />
          </h6>
        </Col>
        <Col lg={6} md={9}>
          <div className="mb-3" style={{ width: "392px" }}>
            <FormField
              id="additional_information.title"
              field_id="additional_information.title"
              label={intl.formatMessage({
                id: "quote.quoteTitle",
                defaultMessage: "Quote title",
              })}
              eventContext="Provider Quotation Form"
              type="textinput"
              placeholder={intl.formatMessage({
                id: "quote.quoteTitle",
                defaultMessage: "Quote title",
              })}
            />
          </div>
          <div className="mb-3" style={{ width: "392px" }}>
            <FormField
              id="additional_information.tracking_number"
              field_id="additional_information.tracking_number"
              label={intl.formatMessage({
                id: "quote-request.trackingNumber",
                defaultMessage: "Tracking number",
              })}
              eventContext="Provider Quotation Form"
              type="textinput"
              placeholder={intl.formatMessage({
                id: "quote-request.trackingNumber",
                defaultMessage: "Tracking number",
              })}
            />
          </div>
          <div className="mb-3" style={{ width: "392px" }}>
            <label className="mb-1">
              <FormattedMessage id="general.additionalComments" defaultMessage="Additional comments" />
            </label>
            <Textarea
              name="additional_information.comments"
              placeholder={intl.formatMessage({
                id: "general.additionalComments",
                defaultMessage: "Additional comments",
              })}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default AdditionalInformation;
